export default "__VITE_ASSET__4e0b8197__"